module["exports"] = ["com.au", "com", "net.au", "net", "org.au", "org"];